export const getCodeType = (type) => {
  switch (type) {
    case 'text':
      return '文字';
    case 'qr':
      return 'QR碼';
    case 'mc-qr':
      return 'QR碼';
    case 'link':
      return '連結';
    default:
      return '';
  }
};

export const getCodeFormat = (format) => {
  switch (format) {
    case 'single_code':
      return '通用優惠 (可供多次使用)';
    case 'multiple_code':
      return '獨特優惠 (一次性優惠碼)';
    default:
      return '';
  }
};

export const isAdminPermit = (status, action) => {
  status = status.toUpperCase();
  const statusActionTable = {
    PENDING: {
      APPROVED: true,
      REJECTED: true,
      EDIT: true,
      PREVIEW: true,
      REMOVED: true,
      STOPPED: false,
      REDEMPTION_STATUS: false,
    },
    SCHEDULED: {
      APPROVED: false,
      REJECTED: false,
      EDIT: true,
      PREVIEW: true,
      REMOVED: true,
      STOPPED: true,
      REDEMPTION_STATUS: false,
    },
    PUBLISHED: {
      APPROVED: false,
      REJECTED: false,
      EDIT: true,
      PREVIEW: false,
      REMOVED: false,
      STOPPED: true,
      REDEMPTION_STATUS: true,
    },
    STOPPED: {
      APPROVED: true,
      REJECTED: false,
      EDIT: true,
      PREVIEW: true,
      REMOVED: true,
      STOPPED: false,
      REDEMPTION_STATUS: true,
    },
    EXPIRED: {
      APPROVED: false,
      REJECTED: false,
      EDIT: true,
      PREVIEW: true,
      REMOVED: true,
      STOPPED: false,
      REDEMPTION_STATUS: true,
    },
    REJECTED: {
      APPROVED: true,
      REJECTED: false,
      EDIT: true,
      PREVIEW: true,
      REMOVED: true,
      STOPPED: false,
      REDEMPTION_STATUS: false,
    },
    REMOVED: {
      APPROVED: false,
      REJECTED: false,
      EDIT: false,
      PREVIEW: true,
      REMOVED: false,
      STOPPED: false,
      REDEMPTION_STATUS: false,
    },
  };
  return statusActionTable[status][action];
};

export const isMerchantPermit = (status, action) => {
  if (!status) {
    return false;
  }
  status = status.toUpperCase();
  const statusActionTable = {
    PENDING: {
      PREVIEW: true,
    },
    SCHEDULED: {
      PREVIEW: true,
    },
    PUBLISHED: {
      PREVIEW: true,
      REDEMPTION_STATUS: true,
    },
    STOPPED: {
      PREVIEW: true,
      REDEMPTION_STATUS: true,
    },
    EXPIRED: {
      PREVIEW: true,
      REDEMPTION_STATUS: true,
    },
    REJECTED: {
      PREVIEW: true,
      EDIT: true,
    },
    REMOVED: {
      PREVIEW: true,
    },
  };
  return statusActionTable[status][action];
};
